// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file app.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BacktestResult } from "./backtest_pb";
import { file_backtest } from "./backtest_pb";
import type { EmptySchema } from "./common_pb";
import { file_common } from "./common_pb";
import type { ConfigurableListSchema, GetParamsRequestSchema, ParamsResponseSchema, ProviderConfig, ProviderInfosResponseSchema, ValidateResponseSchema } from "./configurable_pb";
import { file_configurable } from "./configurable_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { SymbolsResponseSchema } from "./market_pb";
import { file_market } from "./market_pb";
import type { AccountId, AccountIdSchema, BacktestId, BacktestIdSchema, ChannelIdSchema, ScriptId, ScriptIdSchema, TickerBotIdSchema } from "./ids_pb";
import { file_ids } from "./ids_pb";
import type { AccountChannel, AccountChannelSchema, BacktestChannel, BacktestChannelSchema, ChannelSchema, ChannelUpdateSchema, ListChannelsResponseSchema, UpsertChannelRequestSchema } from "./channel_pb";
import { file_channel } from "./channel_pb";
import type { ListTickerBotsResponseSchema, TickerBotLinkSchema, TickerBotSchema, TickerBotUpdateSchema, TickerStateUpdateSchema, UpsertTickerBotRequestSchema } from "./ticker_bot_pb";
import { file_ticker_bot } from "./ticker_bot_pb";
import type { OrderStatsSchema } from "./order_stats_pb";
import { file_order_stats } from "./order_stats_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file app.proto.
 */
export const file_app: GenFile = /*@__PURE__*/
  fileDesc("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", [file_backtest, file_common, file_configurable, file_google_protobuf_struct, file_google_protobuf_timestamp, file_market, file_ids, file_channel, file_ticker_bot, file_order_stats]);

/**
 * @generated from message cryptotrader.Account
 */
export type Account = Message<"cryptotrader.Account"> & {
  /**
   * @generated from field: repeated cryptotrader.AccountChannel channels = 11;
   */
  channels: AccountChannel[];

  /**
   * @generated from field: cryptotrader.AccountId id = 1;
   */
  id?: AccountId | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * provider name + config (secrets redacted)
   *
   * @generated from field: cryptotrader.ProviderConfig provider = 5;
   */
  provider?: ProviderConfig | undefined;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;

  /**
   * populated from runtime, not DB
   *
   * @generated from field: cryptotrader.AccountStatus status = 7;
   */
  status: AccountStatus;

  /**
   * populated from runtime, not DB
   *
   * @generated from field: string status_msg = 8;
   */
  statusMsg: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema: GenMessage<Account> = /*@__PURE__*/
  messageDesc(file_app, 0);

/**
 * @generated from message cryptotrader.Script
 */
export type Script = Message<"cryptotrader.Script"> & {
  /**
   * @generated from field: cryptotrader.ScriptId id = 1;
   */
  id?: ScriptId | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * "pine", future: "python", etc.
   *
   * @generated from field: string language = 5;
   */
  language: string;

  /**
   * latest revision's source
   *
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * latest revision number
   *
   * @generated from field: int32 rev_no = 9;
   */
  revNo: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.Script.
 * Use `create(ScriptSchema)` to create a new message.
 */
export const ScriptSchema: GenMessage<Script> = /*@__PURE__*/
  messageDesc(file_app, 1);

/**
 * @generated from message cryptotrader.ScriptRevision
 */
export type ScriptRevision = Message<"cryptotrader.ScriptRevision"> & {
  /**
   * @generated from field: cryptotrader.ScriptId script_id = 1;
   */
  scriptId?: ScriptId | undefined;

  /**
   * @generated from field: int32 rev_no = 2;
   */
  revNo: number;

  /**
   * populated by Get, empty in List responses
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * source length in bytes (List responses)
   *
   * @generated from field: int32 size = 4;
   */
  size: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.ScriptRevision.
 * Use `create(ScriptRevisionSchema)` to create a new message.
 */
export const ScriptRevisionSchema: GenMessage<ScriptRevision> = /*@__PURE__*/
  messageDesc(file_app, 2);

/**
 * @generated from message cryptotrader.BacktestAccount
 */
export type BacktestAccount = Message<"cryptotrader.BacktestAccount"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * decimal as string, nil = unlimited
   *
   * @generated from field: optional string crypto_limit = 2;
   */
  cryptoLimit?: string | undefined;

  /**
   * decimal as string, nil = unlimited
   *
   * @generated from field: optional string fiat_limit = 3;
   */
  fiatLimit?: string | undefined;

  /**
   * when true, use strategy qty directly (no limits/leverage)
   *
   * @generated from field: bool bypass = 4;
   */
  bypass: boolean;

  /**
   * decimal as string, nil = market orders
   *
   * @generated from field: optional string slippage = 5;
   */
  slippage?: string | undefined;

  /**
   * trade this symbol instead of the backtest's; nil = inherit
   *
   * @generated from field: optional string symbol = 6;
   */
  symbol?: string | undefined;

  /**
   * engine-tagged close orders sent as exchange-enforced reduce-only
   *
   * @generated from field: bool reduce_only = 7;
   */
  reduceOnly: boolean;
};

/**
 * Describes the message cryptotrader.BacktestAccount.
 * Use `create(BacktestAccountSchema)` to create a new message.
 */
export const BacktestAccountSchema: GenMessage<BacktestAccount> = /*@__PURE__*/
  messageDesc(file_app, 3);

/**
 * @generated from message cryptotrader.Backtest
 */
export type Backtest = Message<"cryptotrader.Backtest"> & {
  /**
   * @generated from field: repeated cryptotrader.BacktestChannel channels = 22;
   */
  channels: BacktestChannel[];

  /**
   * @generated from field: cryptotrader.BacktestId id = 1;
   */
  id?: BacktestId | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig market = 5;
   */
  market?: ProviderConfig | undefined;

  /**
   * @generated from field: string symbol = 6;
   */
  symbol: string;

  /**
   * @generated from field: string timeframe = 7;
   */
  timeframe: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig strategy = 8;
   */
  strategy?: ProviderConfig | undefined;

  /**
   * @generated from field: cryptotrader.ProviderConfig engine = 9;
   */
  engine?: ProviderConfig | undefined;

  /**
   * @generated from field: string start_date = 10;
   */
  startDate: string;

  /**
   * @generated from field: optional string end_date = 11;
   */
  endDate?: string | undefined;

  /**
   * @generated from field: bool enabled = 12;
   */
  enabled: boolean;

  /**
   * memory-only, from runtime
   *
   * @generated from field: cryptotrader.BacktestStatus status = 13;
   */
  status: BacktestStatus;

  /**
   * memory-only
   *
   * @generated from field: string status_msg = 14;
   */
  statusMsg: string;

  /**
   * memory-only, set when backtest completes
   *
   * @generated from field: optional cryptotrader.BacktestResult result = 15;
   */
  result?: BacktestResult | undefined;

  /**
   * memory-only, populated on read
   *
   * @generated from field: repeated cryptotrader.BacktestAccount accounts = 16;
   */
  accounts: BacktestAccount[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * optional; e.g. { "ui": { "mode": "lab" } }
   *
   * @generated from field: google.protobuf.Struct metadata = 19;
   */
  metadata?: JsonObject | undefined;

  /**
   * Bar Magnifier timeframe ("1m"); empty = off
   *
   * @generated from field: string bar_magnifier = 20;
   */
  barMagnifier: string;

  /**
   * When the strategy runs on a bar besides its close, as flags: 0 on bar
   * close, 1 after order fills (calc_on_order_fills), 2 on realtime bars
   * (calc_on_every_tick).
   *
   * @generated from field: uint32 recalculate = 21;
   */
  recalculate: number;
};

/**
 * Describes the message cryptotrader.Backtest.
 * Use `create(BacktestSchema)` to create a new message.
 */
export const BacktestSchema: GenMessage<Backtest> = /*@__PURE__*/
  messageDesc(file_app, 4);

/**
 * @generated from message cryptotrader.Balance
 */
export type Balance = Message<"cryptotrader.Balance"> & {
  /**
   * @generated from field: string asset = 1;
   */
  asset: string;

  /**
   * decimal as string
   *
   * @generated from field: string free = 2;
   */
  free: string;

  /**
   * decimal as string
   *
   * @generated from field: string locked = 3;
   */
  locked: string;
};

/**
 * Describes the message cryptotrader.Balance.
 * Use `create(BalanceSchema)` to create a new message.
 */
export const BalanceSchema: GenMessage<Balance> = /*@__PURE__*/
  messageDesc(file_app, 5);

/**
 * @generated from message cryptotrader.BalanceData
 */
export type BalanceData = Message<"cryptotrader.BalanceData"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: repeated cryptotrader.Balance balances = 2;
   */
  balances: Balance[];
};

/**
 * Describes the message cryptotrader.BalanceData.
 * Use `create(BalanceDataSchema)` to create a new message.
 */
export const BalanceDataSchema: GenMessage<BalanceData> = /*@__PURE__*/
  messageDesc(file_app, 6);

/**
 * @generated from message cryptotrader.Position
 */
export type Position = Message<"cryptotrader.Position"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: cryptotrader.PositionSide side = 2;
   */
  side: PositionSide;

  /**
   * decimal as string
   *
   * @generated from field: string size = 3;
   */
  size: string;

  /**
   * decimal as string
   *
   * @generated from field: string entry_price = 4;
   */
  entryPrice: string;

  /**
   * decimal as string
   *
   * @generated from field: string unrealized_pnl = 5;
   */
  unrealizedPnl: string;

  /**
   * @generated from field: int32 leverage = 6;
   */
  leverage: number;
};

/**
 * Describes the message cryptotrader.Position.
 * Use `create(PositionSchema)` to create a new message.
 */
export const PositionSchema: GenMessage<Position> = /*@__PURE__*/
  messageDesc(file_app, 7);

/**
 * @generated from message cryptotrader.PositionData
 */
export type PositionData = Message<"cryptotrader.PositionData"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: repeated cryptotrader.Position positions = 2;
   */
  positions: Position[];
};

/**
 * Describes the message cryptotrader.PositionData.
 * Use `create(PositionDataSchema)` to create a new message.
 */
export const PositionDataSchema: GenMessage<PositionData> = /*@__PURE__*/
  messageDesc(file_app, 8);

/**
 * @generated from message cryptotrader.Leverage
 */
export type Leverage = Message<"cryptotrader.Leverage"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: int32 leverage = 2;
   */
  leverage: number;

  /**
   * decimal as string
   *
   * @generated from field: string max_notional_value = 3;
   */
  maxNotionalValue: string;
};

/**
 * Describes the message cryptotrader.Leverage.
 * Use `create(LeverageSchema)` to create a new message.
 */
export const LeverageSchema: GenMessage<Leverage> = /*@__PURE__*/
  messageDesc(file_app, 9);

/**
 * @generated from message cryptotrader.LeverageData
 */
export type LeverageData = Message<"cryptotrader.LeverageData"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: repeated cryptotrader.Leverage leverages = 2;
   */
  leverages: Leverage[];
};

/**
 * Describes the message cryptotrader.LeverageData.
 * Use `create(LeverageDataSchema)` to create a new message.
 */
export const LeverageDataSchema: GenMessage<LeverageData> = /*@__PURE__*/
  messageDesc(file_app, 10);

/**
 * @generated from message cryptotrader.OrderData
 */
export type OrderData = Message<"cryptotrader.OrderData"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: string order_id = 2;
   */
  orderId: string;

  /**
   * @generated from field: string symbol = 3;
   */
  symbol: string;

  /**
   * @generated from field: cryptotrader.OrderSide side = 4;
   */
  side: OrderSide;

  /**
   * @generated from field: cryptotrader.OrderType type = 5;
   */
  type: OrderType;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * decimal as string
   *
   * @generated from field: string price = 7;
   */
  price: string;

  /**
   * decimal as string
   *
   * @generated from field: string quantity = 8;
   */
  quantity: string;
};

/**
 * Describes the message cryptotrader.OrderData.
 * Use `create(OrderDataSchema)` to create a new message.
 */
export const OrderDataSchema: GenMessage<OrderData> = /*@__PURE__*/
  messageDesc(file_app, 11);

/**
 * @generated from message cryptotrader.OrderRecord
 */
export type OrderRecord = Message<"cryptotrader.OrderRecord"> & {
  /**
   * row id (uuid)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: cryptotrader.AccountId account_id = 3;
   */
  accountId?: AccountId | undefined;

  /**
   * absent = ticker bot / manual
   *
   * @generated from field: cryptotrader.BacktestId backtest_id = 4;
   */
  backtestId?: BacktestId | undefined;

  /**
   * "strategy" | "ticker_bot" | "external"
   *
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: string symbol = 6;
   */
  symbol: string;

  /**
   * @generated from field: cryptotrader.OrderSide side = 7;
   */
  side: OrderSide;

  /**
   * UNSPECIFIED = spot / none
   *
   * @generated from field: cryptotrader.PositionSide position_side = 8;
   */
  positionSide: PositionSide;

  /**
   * @generated from field: cryptotrader.OrderType order_type = 9;
   */
  orderType: OrderType;

  /**
   * pending | done | error | skipped | canceled
   *
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * raw exchange status (FILLED, EXPIRED, ...)
   *
   * @generated from field: string exchange_status = 11;
   */
  exchangeStatus: string;

  /**
   * @generated from field: string requested_price = 12;
   */
  requestedPrice: string;

  /**
   * @generated from field: string requested_qty = 13;
   */
  requestedQty: string;

  /**
   * QuoteOrderQty (quote-sized spot buys)
   *
   * @generated from field: string requested_quote = 14;
   */
  requestedQuote: string;

  /**
   * @generated from field: string executed_price = 15;
   */
  executedPrice: string;

  /**
   * @generated from field: string executed_qty = 16;
   */
  executedQty: string;

  /**
   * @generated from field: string quote_spent = 17;
   */
  quoteSpent: string;

  /**
   * @generated from field: optional string crypto_limit_before = 18;
   */
  cryptoLimitBefore?: string | undefined;

  /**
   * @generated from field: optional string fiat_limit_before = 19;
   */
  fiatLimitBefore?: string | undefined;

  /**
   * @generated from field: optional string crypto_limit_after = 20;
   */
  cryptoLimitAfter?: string | undefined;

  /**
   * @generated from field: optional string fiat_limit_after = 21;
   */
  fiatLimitAfter?: string | undefined;

  /**
   * @generated from field: string exchange_order_id = 22;
   */
  exchangeOrderId: string;

  /**
   * @generated from field: string comment = 23;
   */
  comment: string;

  /**
   * @generated from field: string error = 24;
   */
  error: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 25;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 26;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.OrderRecord.
 * Use `create(OrderRecordSchema)` to create a new message.
 */
export const OrderRecordSchema: GenMessage<OrderRecord> = /*@__PURE__*/
  messageDesc(file_app, 12);

/**
 * @generated from message cryptotrader.SubscribeOrdersRequest
 */
export type SubscribeOrdersRequest = Message<"cryptotrader.SubscribeOrdersRequest"> & {
  /**
   * optional: empty = all the user's accounts
   *
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * snapshot filter
   *
   * @generated from field: optional cryptotrader.BacktestId backtest_id = 2;
   */
  backtestId?: BacktestId | undefined;

  /**
   * snapshot filter
   *
   * @generated from field: optional string status = 3;
   */
  status?: string | undefined;

  /**
   * snapshot depth, default 50
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message cryptotrader.SubscribeOrdersRequest.
 * Use `create(SubscribeOrdersRequestSchema)` to create a new message.
 */
export const SubscribeOrdersRequestSchema: GenMessage<SubscribeOrdersRequest> = /*@__PURE__*/
  messageDesc(file_app, 13);

/**
 * @generated from message cryptotrader.ListOrdersResponse
 */
export type ListOrdersResponse = Message<"cryptotrader.ListOrdersResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.OrderRecord orders = 1;
   */
  orders: OrderRecord[];
};

/**
 * Describes the message cryptotrader.ListOrdersResponse.
 * Use `create(ListOrdersResponseSchema)` to create a new message.
 */
export const ListOrdersResponseSchema: GenMessage<ListOrdersResponse> = /*@__PURE__*/
  messageDesc(file_app, 14);

/**
 * @generated from message cryptotrader.OrderUpdate
 */
export type OrderUpdate = Message<"cryptotrader.OrderUpdate"> & {
  /**
   * @generated from oneof cryptotrader.OrderUpdate.payload
   */
  payload: {
    /**
     * history for the account
     *
     * @generated from field: cryptotrader.ListOrdersResponse snapshot = 1;
     */
    value: ListOrdersResponse;
    case: "snapshot";
  } | {
    /**
     * insert or status transition
     *
     * @generated from field: cryptotrader.OrderRecord upserted = 2;
     */
    value: OrderRecord;
    case: "upserted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.OrderUpdate.
 * Use `create(OrderUpdateSchema)` to create a new message.
 */
export const OrderUpdateSchema: GenMessage<OrderUpdate> = /*@__PURE__*/
  messageDesc(file_app, 15);

/**
 * @generated from message cryptotrader.AccountInput
 */
export type AccountInput = Message<"cryptotrader.AccountInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig provider = 3;
   */
  provider?: ProviderConfig | undefined;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message cryptotrader.AccountInput.
 * Use `create(AccountInputSchema)` to create a new message.
 */
export const AccountInputSchema: GenMessage<AccountInput> = /*@__PURE__*/
  messageDesc(file_app, 16);

/**
 * @generated from message cryptotrader.ScriptInput
 */
export type ScriptInput = Message<"cryptotrader.ScriptInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string language = 3;
   */
  language: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;
};

/**
 * Describes the message cryptotrader.ScriptInput.
 * Use `create(ScriptInputSchema)` to create a new message.
 */
export const ScriptInputSchema: GenMessage<ScriptInput> = /*@__PURE__*/
  messageDesc(file_app, 17);

/**
 * @generated from message cryptotrader.BacktestInput
 */
export type BacktestInput = Message<"cryptotrader.BacktestInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig market = 3;
   */
  market?: ProviderConfig | undefined;

  /**
   * @generated from field: string symbol = 4;
   */
  symbol: string;

  /**
   * @generated from field: string timeframe = 5;
   */
  timeframe: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig strategy = 6;
   */
  strategy?: ProviderConfig | undefined;

  /**
   * @generated from field: cryptotrader.ProviderConfig engine = 7;
   */
  engine?: ProviderConfig | undefined;

  /**
   * @generated from field: string start_date = 8;
   */
  startDate: string;

  /**
   * @generated from field: optional string end_date = 9;
   */
  endDate?: string | undefined;

  /**
   * @generated from field: bool enabled = 10;
   */
  enabled: boolean;

  /**
   * omission clears metadata
   *
   * @generated from field: google.protobuf.Struct metadata = 11;
   */
  metadata?: JsonObject | undefined;

  /**
   * Full-state input: omitted fields reset to their defaults.
   *
   * @generated from field: string bar_magnifier = 12;
   */
  barMagnifier: string;

  /**
   * Backtest.recalculate's flags
   *
   * @generated from field: uint32 recalculate = 13;
   */
  recalculate: number;
};

/**
 * Describes the message cryptotrader.BacktestInput.
 * Use `create(BacktestInputSchema)` to create a new message.
 */
export const BacktestInputSchema: GenMessage<BacktestInput> = /*@__PURE__*/
  messageDesc(file_app, 18);

/**
 * Upserts create when id is absent; a present id must exist and belong to the caller.
 * Inputs replace all editable fields; omitted fields reset to defaults.
 *
 * @generated from message cryptotrader.UpsertAccountRequest
 */
export type UpsertAccountRequest = Message<"cryptotrader.UpsertAccountRequest"> & {
  /**
   * @generated from field: cryptotrader.AccountId id = 1;
   */
  id?: AccountId | undefined;

  /**
   * @generated from field: cryptotrader.AccountInput input = 2;
   */
  input?: AccountInput | undefined;
};

/**
 * Describes the message cryptotrader.UpsertAccountRequest.
 * Use `create(UpsertAccountRequestSchema)` to create a new message.
 */
export const UpsertAccountRequestSchema: GenMessage<UpsertAccountRequest> = /*@__PURE__*/
  messageDesc(file_app, 19);

/**
 * @generated from message cryptotrader.ToggleAccountRequest
 */
export type ToggleAccountRequest = Message<"cryptotrader.ToggleAccountRequest"> & {
  /**
   * @generated from field: cryptotrader.AccountId id = 1;
   */
  id?: AccountId | undefined;

  /**
   * true = start, false = stop
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message cryptotrader.ToggleAccountRequest.
 * Use `create(ToggleAccountRequestSchema)` to create a new message.
 */
export const ToggleAccountRequestSchema: GenMessage<ToggleAccountRequest> = /*@__PURE__*/
  messageDesc(file_app, 20);

/**
 * @generated from message cryptotrader.ToggleBacktestRequest
 */
export type ToggleBacktestRequest = Message<"cryptotrader.ToggleBacktestRequest"> & {
  /**
   * @generated from field: cryptotrader.BacktestId id = 1;
   */
  id?: BacktestId | undefined;

  /**
   * desired state; retries do not invert it
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message cryptotrader.ToggleBacktestRequest.
 * Use `create(ToggleBacktestRequestSchema)` to create a new message.
 */
export const ToggleBacktestRequestSchema: GenMessage<ToggleBacktestRequest> = /*@__PURE__*/
  messageDesc(file_app, 21);

/**
 * @generated from message cryptotrader.SetLeverageRequest
 */
export type SetLeverageRequest = Message<"cryptotrader.SetLeverageRequest"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: int32 leverage = 3;
   */
  leverage: number;
};

/**
 * Describes the message cryptotrader.SetLeverageRequest.
 * Use `create(SetLeverageRequestSchema)` to create a new message.
 */
export const SetLeverageRequestSchema: GenMessage<SetLeverageRequest> = /*@__PURE__*/
  messageDesc(file_app, 22);

/**
 * @generated from message cryptotrader.UpsertScriptRequest
 */
export type UpsertScriptRequest = Message<"cryptotrader.UpsertScriptRequest"> & {
  /**
   * @generated from field: cryptotrader.ScriptId id = 1;
   */
  id?: ScriptId | undefined;

  /**
   * @generated from field: cryptotrader.ScriptInput input = 2;
   */
  input?: ScriptInput | undefined;
};

/**
 * Describes the message cryptotrader.UpsertScriptRequest.
 * Use `create(UpsertScriptRequestSchema)` to create a new message.
 */
export const UpsertScriptRequestSchema: GenMessage<UpsertScriptRequest> = /*@__PURE__*/
  messageDesc(file_app, 23);

/**
 * @generated from message cryptotrader.ListScriptsResponse
 */
export type ListScriptsResponse = Message<"cryptotrader.ListScriptsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.Script scripts = 1;
   */
  scripts: Script[];
};

/**
 * Describes the message cryptotrader.ListScriptsResponse.
 * Use `create(ListScriptsResponseSchema)` to create a new message.
 */
export const ListScriptsResponseSchema: GenMessage<ListScriptsResponse> = /*@__PURE__*/
  messageDesc(file_app, 24);

/**
 * @generated from message cryptotrader.GetScriptRevisionRequest
 */
export type GetScriptRevisionRequest = Message<"cryptotrader.GetScriptRevisionRequest"> & {
  /**
   * @generated from field: cryptotrader.ScriptId script_id = 1;
   */
  scriptId?: ScriptId | undefined;

  /**
   * required: >= 1; references must pin a revision
   *
   * @generated from field: int32 rev_no = 2;
   */
  revNo: number;
};

/**
 * Describes the message cryptotrader.GetScriptRevisionRequest.
 * Use `create(GetScriptRevisionRequestSchema)` to create a new message.
 */
export const GetScriptRevisionRequestSchema: GenMessage<GetScriptRevisionRequest> = /*@__PURE__*/
  messageDesc(file_app, 25);

/**
 * @generated from message cryptotrader.ListScriptRevisionsRequest
 */
export type ListScriptRevisionsRequest = Message<"cryptotrader.ListScriptRevisionsRequest"> & {
  /**
   * @generated from field: cryptotrader.ScriptId script_id = 1;
   */
  scriptId?: ScriptId | undefined;
};

/**
 * Describes the message cryptotrader.ListScriptRevisionsRequest.
 * Use `create(ListScriptRevisionsRequestSchema)` to create a new message.
 */
export const ListScriptRevisionsRequestSchema: GenMessage<ListScriptRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_app, 26);

/**
 * @generated from message cryptotrader.ListScriptRevisionsResponse
 */
export type ListScriptRevisionsResponse = Message<"cryptotrader.ListScriptRevisionsResponse"> & {
  /**
   * newest first, source empty
   *
   * @generated from field: repeated cryptotrader.ScriptRevision revisions = 1;
   */
  revisions: ScriptRevision[];
};

/**
 * Describes the message cryptotrader.ListScriptRevisionsResponse.
 * Use `create(ListScriptRevisionsResponseSchema)` to create a new message.
 */
export const ListScriptRevisionsResponseSchema: GenMessage<ListScriptRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_app, 27);

/**
 * @generated from message cryptotrader.UpsertBacktestRequest
 */
export type UpsertBacktestRequest = Message<"cryptotrader.UpsertBacktestRequest"> & {
  /**
   * @generated from field: cryptotrader.BacktestId id = 1;
   */
  id?: BacktestId | undefined;

  /**
   * @generated from field: cryptotrader.BacktestInput input = 2;
   */
  input?: BacktestInput | undefined;
};

/**
 * Describes the message cryptotrader.UpsertBacktestRequest.
 * Use `create(UpsertBacktestRequestSchema)` to create a new message.
 */
export const UpsertBacktestRequestSchema: GenMessage<UpsertBacktestRequest> = /*@__PURE__*/
  messageDesc(file_app, 28);

/**
 * @generated from message cryptotrader.AddBacktestAccountRequest
 */
export type AddBacktestAccountRequest = Message<"cryptotrader.AddBacktestAccountRequest"> & {
  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 1;
   */
  backtestId?: BacktestId | undefined;

  /**
   * @generated from field: cryptotrader.AccountId account_id = 2;
   */
  accountId?: AccountId | undefined;

  /**
   * decimal as string
   *
   * @generated from field: optional string crypto_limit = 3;
   */
  cryptoLimit?: string | undefined;

  /**
   * decimal as string
   *
   * @generated from field: optional string fiat_limit = 4;
   */
  fiatLimit?: string | undefined;

  /**
   * @generated from field: bool bypass = 5;
   */
  bypass: boolean;

  /**
   * decimal as string, nil = market orders
   *
   * @generated from field: optional string slippage = 6;
   */
  slippage?: string | undefined;

  /**
   * trade this symbol instead of the backtest's; nil = inherit
   *
   * @generated from field: optional string symbol = 7;
   */
  symbol?: string | undefined;

  /**
   * @generated from field: bool reduce_only = 8;
   */
  reduceOnly: boolean;
};

/**
 * Describes the message cryptotrader.AddBacktestAccountRequest.
 * Use `create(AddBacktestAccountRequestSchema)` to create a new message.
 */
export const AddBacktestAccountRequestSchema: GenMessage<AddBacktestAccountRequest> = /*@__PURE__*/
  messageDesc(file_app, 29);

/**
 * @generated from message cryptotrader.RemoveBacktestAccountRequest
 */
export type RemoveBacktestAccountRequest = Message<"cryptotrader.RemoveBacktestAccountRequest"> & {
  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 1;
   */
  backtestId?: BacktestId | undefined;

  /**
   * @generated from field: cryptotrader.AccountId account_id = 2;
   */
  accountId?: AccountId | undefined;
};

/**
 * Describes the message cryptotrader.RemoveBacktestAccountRequest.
 * Use `create(RemoveBacktestAccountRequestSchema)` to create a new message.
 */
export const RemoveBacktestAccountRequestSchema: GenMessage<RemoveBacktestAccountRequest> = /*@__PURE__*/
  messageDesc(file_app, 30);

/**
 * @generated from message cryptotrader.UpdateBacktestAccountRequest
 */
export type UpdateBacktestAccountRequest = Message<"cryptotrader.UpdateBacktestAccountRequest"> & {
  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 1;
   */
  backtestId?: BacktestId | undefined;

  /**
   * @generated from field: cryptotrader.AccountId account_id = 2;
   */
  accountId?: AccountId | undefined;

  /**
   * decimal as string
   *
   * @generated from field: optional string crypto_limit = 3;
   */
  cryptoLimit?: string | undefined;

  /**
   * decimal as string
   *
   * @generated from field: optional string fiat_limit = 4;
   */
  fiatLimit?: string | undefined;

  /**
   * @generated from field: bool bypass = 5;
   */
  bypass: boolean;

  /**
   * decimal as string, nil = market orders
   *
   * @generated from field: optional string slippage = 6;
   */
  slippage?: string | undefined;

  /**
   * trade this symbol instead of the backtest's; nil = inherit
   *
   * @generated from field: optional string symbol = 7;
   */
  symbol?: string | undefined;

  /**
   * @generated from field: bool reduce_only = 8;
   */
  reduceOnly: boolean;
};

/**
 * Describes the message cryptotrader.UpdateBacktestAccountRequest.
 * Use `create(UpdateBacktestAccountRequestSchema)` to create a new message.
 */
export const UpdateBacktestAccountRequestSchema: GenMessage<UpdateBacktestAccountRequest> = /*@__PURE__*/
  messageDesc(file_app, 31);

/**
 * @generated from message cryptotrader.ListAccountsResponse
 */
export type ListAccountsResponse = Message<"cryptotrader.ListAccountsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.Account accounts = 1;
   */
  accounts: Account[];
};

/**
 * Describes the message cryptotrader.ListAccountsResponse.
 * Use `create(ListAccountsResponseSchema)` to create a new message.
 */
export const ListAccountsResponseSchema: GenMessage<ListAccountsResponse> = /*@__PURE__*/
  messageDesc(file_app, 32);

/**
 * @generated from message cryptotrader.ListBacktestsResponse
 */
export type ListBacktestsResponse = Message<"cryptotrader.ListBacktestsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.Backtest backtests = 1;
   */
  backtests: Backtest[];
};

/**
 * Describes the message cryptotrader.ListBacktestsResponse.
 * Use `create(ListBacktestsResponseSchema)` to create a new message.
 */
export const ListBacktestsResponseSchema: GenMessage<ListBacktestsResponse> = /*@__PURE__*/
  messageDesc(file_app, 33);

/**
 * @generated from message cryptotrader.AccountUpdate
 */
export type AccountUpdate = Message<"cryptotrader.AccountUpdate"> & {
  /**
   * @generated from oneof cryptotrader.AccountUpdate.payload
   */
  payload: {
    /**
     * initial full list
     *
     * @generated from field: cryptotrader.ListAccountsResponse snapshot = 1;
     */
    value: ListAccountsResponse;
    case: "snapshot";
  } | {
    /**
     * created or updated
     *
     * @generated from field: cryptotrader.Account upserted = 2;
     */
    value: Account;
    case: "upserted";
  } | {
    /**
     * account ID removed
     *
     * @generated from field: cryptotrader.AccountId deleted = 3;
     */
    value: AccountId;
    case: "deleted";
  } | {
    /**
     * live balance update
     *
     * @generated from field: cryptotrader.BalanceData balance = 4;
     */
    value: BalanceData;
    case: "balance";
  } | {
    /**
     * live position update
     *
     * @generated from field: cryptotrader.PositionData position = 5;
     */
    value: PositionData;
    case: "position";
  } | {
    /**
     * leverage change
     *
     * @generated from field: cryptotrader.LeverageData leverage = 6;
     */
    value: LeverageData;
    case: "leverage";
  } | {
    /**
     * order fill/cancel
     *
     * @generated from field: cryptotrader.OrderData order = 7;
     */
    value: OrderData;
    case: "order";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.AccountUpdate.
 * Use `create(AccountUpdateSchema)` to create a new message.
 */
export const AccountUpdateSchema: GenMessage<AccountUpdate> = /*@__PURE__*/
  messageDesc(file_app, 34);

/**
 * @generated from message cryptotrader.ScriptUpdate
 */
export type ScriptUpdate = Message<"cryptotrader.ScriptUpdate"> & {
  /**
   * @generated from oneof cryptotrader.ScriptUpdate.payload
   */
  payload: {
    /**
     * @generated from field: cryptotrader.ListScriptsResponse snapshot = 1;
     */
    value: ListScriptsResponse;
    case: "snapshot";
  } | {
    /**
     * @generated from field: cryptotrader.Script upserted = 2;
     */
    value: Script;
    case: "upserted";
  } | {
    /**
     * @generated from field: cryptotrader.ScriptId deleted = 3;
     */
    value: ScriptId;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.ScriptUpdate.
 * Use `create(ScriptUpdateSchema)` to create a new message.
 */
export const ScriptUpdateSchema: GenMessage<ScriptUpdate> = /*@__PURE__*/
  messageDesc(file_app, 35);

/**
 * @generated from message cryptotrader.BacktestResultWithId
 */
export type BacktestResultWithId = Message<"cryptotrader.BacktestResultWithId"> & {
  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 1;
   */
  backtestId?: BacktestId | undefined;

  /**
   * @generated from field: cryptotrader.BacktestResult result = 2;
   */
  result?: BacktestResult | undefined;
};

/**
 * Describes the message cryptotrader.BacktestResultWithId.
 * Use `create(BacktestResultWithIdSchema)` to create a new message.
 */
export const BacktestResultWithIdSchema: GenMessage<BacktestResultWithId> = /*@__PURE__*/
  messageDesc(file_app, 36);

/**
 * @generated from message cryptotrader.BacktestUpdate
 */
export type BacktestUpdate = Message<"cryptotrader.BacktestUpdate"> & {
  /**
   * @generated from oneof cryptotrader.BacktestUpdate.payload
   */
  payload: {
    /**
     * initial full list
     *
     * @generated from field: cryptotrader.ListBacktestsResponse snapshot = 1;
     */
    value: ListBacktestsResponse;
    case: "snapshot";
  } | {
    /**
     * created or updated
     *
     * @generated from field: cryptotrader.Backtest upserted = 2;
     */
    value: Backtest;
    case: "upserted";
  } | {
    /**
     * backtest ID removed
     *
     * @generated from field: cryptotrader.BacktestId deleted = 3;
     */
    value: BacktestId;
    case: "deleted";
  } | {
    /**
     * backtest completed
     *
     * @generated from field: cryptotrader.BacktestResultWithId result = 4;
     */
    value: BacktestResultWithId;
    case: "result";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.BacktestUpdate.
 * Use `create(BacktestUpdateSchema)` to create a new message.
 */
export const BacktestUpdateSchema: GenMessage<BacktestUpdate> = /*@__PURE__*/
  messageDesc(file_app, 37);

/**
 * @generated from message cryptotrader.ListOrdersRequest
 */
export type ListOrdersRequest = Message<"cryptotrader.ListOrdersRequest"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 2;
   */
  backtestId?: BacktestId | undefined;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message cryptotrader.ListOrdersRequest.
 * Use `create(ListOrdersRequestSchema)` to create a new message.
 */
export const ListOrdersRequestSchema: GenMessage<ListOrdersRequest> = /*@__PURE__*/
  messageDesc(file_app, 38);

/**
 * @generated from message cryptotrader.GetOrderStatsRequest
 */
export type GetOrderStatsRequest = Message<"cryptotrader.GetOrderStatsRequest"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 2;
   */
  backtestId?: BacktestId | undefined;
};

/**
 * Describes the message cryptotrader.GetOrderStatsRequest.
 * Use `create(GetOrderStatsRequestSchema)` to create a new message.
 */
export const GetOrderStatsRequestSchema: GenMessage<GetOrderStatsRequest> = /*@__PURE__*/
  messageDesc(file_app, 39);

/**
 * @generated from enum cryptotrader.AccountStatus
 */
export enum AccountStatus {
  /**
   * @generated from enum value: ACCOUNT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_STATUS_STOPPED = 1;
   */
  STOPPED = 1,

  /**
   * @generated from enum value: ACCOUNT_STATUS_CONNECTING = 2;
   */
  CONNECTING = 2,

  /**
   * @generated from enum value: ACCOUNT_STATUS_RUNNING = 3;
   */
  RUNNING = 3,

  /**
   * @generated from enum value: ACCOUNT_STATUS_ERROR = 4;
   */
  ERROR = 4,

  /**
   * @generated from enum value: ACCOUNT_STATUS_DISABLED = 5;
   */
  DISABLED = 5,
}

/**
 * Describes the enum cryptotrader.AccountStatus.
 */
export const AccountStatusSchema: GenEnum<AccountStatus> = /*@__PURE__*/
  enumDesc(file_app, 0);

/**
 * @generated from enum cryptotrader.BacktestStatus
 */
export enum BacktestStatus {
  /**
   * @generated from enum value: BACKTEST_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BACKTEST_STATUS_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: BACKTEST_STATUS_STOPPED = 2;
   */
  STOPPED = 2,

  /**
   * @generated from enum value: BACKTEST_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum cryptotrader.BacktestStatus.
 */
export const BacktestStatusSchema: GenEnum<BacktestStatus> = /*@__PURE__*/
  enumDesc(file_app, 1);

/**
 * @generated from enum cryptotrader.OrderSide
 */
export enum OrderSide {
  /**
   * @generated from enum value: ORDER_SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_SIDE_BUY = 1;
   */
  BUY = 1,

  /**
   * @generated from enum value: ORDER_SIDE_SELL = 2;
   */
  SELL = 2,
}

/**
 * Describes the enum cryptotrader.OrderSide.
 */
export const OrderSideSchema: GenEnum<OrderSide> = /*@__PURE__*/
  enumDesc(file_app, 2);

/**
 * @generated from enum cryptotrader.OrderType
 */
export enum OrderType {
  /**
   * @generated from enum value: ORDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_TYPE_MARKET = 1;
   */
  MARKET = 1,

  /**
   * @generated from enum value: ORDER_TYPE_LIMIT = 2;
   */
  LIMIT = 2,
}

/**
 * Describes the enum cryptotrader.OrderType.
 */
export const OrderTypeSchema: GenEnum<OrderType> = /*@__PURE__*/
  enumDesc(file_app, 3);

/**
 * @generated from enum cryptotrader.PositionSide
 */
export enum PositionSide {
  /**
   * @generated from enum value: POSITION_SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POSITION_SIDE_LONG = 1;
   */
  LONG = 1,

  /**
   * @generated from enum value: POSITION_SIDE_SHORT = 2;
   */
  SHORT = 2,
}

/**
 * Describes the enum cryptotrader.PositionSide.
 */
export const PositionSideSchema: GenEnum<PositionSide> = /*@__PURE__*/
  enumDesc(file_app, 4);

/**
 * @generated from service cryptotrader.AppService
 */
export const AppService: GenService<{
  /**
   * @generated from rpc cryptotrader.AppService.ListOrders
   */
  listOrders: {
    methodKind: "unary";
    input: typeof ListOrdersRequestSchema;
    output: typeof ListOrdersResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetOrderStats
   */
  getOrderStats: {
    methodKind: "unary";
    input: typeof GetOrderStatsRequestSchema;
    output: typeof OrderStatsSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.UpsertChannel
   */
  upsertChannel: {
    methodKind: "unary";
    input: typeof UpsertChannelRequestSchema;
    output: typeof ChannelSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetChannel
   */
  getChannel: {
    methodKind: "unary";
    input: typeof ChannelIdSchema;
    output: typeof ChannelSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ListChannels
   */
  listChannels: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListChannelsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.DeleteChannel
   */
  deleteChannel: {
    methodKind: "unary";
    input: typeof ChannelIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.TestChannel
   */
  testChannel: {
    methodKind: "unary";
    input: typeof ChannelIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeChannels
   */
  subscribeChannels: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof ChannelUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.AddAccountChannel
   */
  addAccountChannel: {
    methodKind: "unary";
    input: typeof AccountChannelSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.RemoveAccountChannel
   */
  removeAccountChannel: {
    methodKind: "unary";
    input: typeof AccountChannelSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.AddBacktestChannel
   */
  addBacktestChannel: {
    methodKind: "unary";
    input: typeof BacktestChannelSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.RemoveBacktestChannel
   */
  removeBacktestChannel: {
    methodKind: "unary";
    input: typeof BacktestChannelSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.UpsertTickerBot
   */
  upsertTickerBot: {
    methodKind: "unary";
    input: typeof UpsertTickerBotRequestSchema;
    output: typeof TickerBotSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetTickerBot
   */
  getTickerBot: {
    methodKind: "unary";
    input: typeof TickerBotIdSchema;
    output: typeof TickerBotSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ListTickerBots
   */
  listTickerBots: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListTickerBotsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.DeleteTickerBot
   */
  deleteTickerBot: {
    methodKind: "unary";
    input: typeof TickerBotIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.AddTickerBotLink
   */
  addTickerBotLink: {
    methodKind: "unary";
    input: typeof TickerBotLinkSchema;
    output: typeof TickerBotSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.RemoveTickerBotLink
   */
  removeTickerBotLink: {
    methodKind: "unary";
    input: typeof TickerBotLinkSchema;
    output: typeof TickerBotSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeTickerBots
   */
  subscribeTickerBots: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof TickerBotUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeTickerState
   */
  subscribeTickerState: {
    methodKind: "server_streaming";
    input: typeof TickerBotIdSchema;
    output: typeof TickerStateUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.UpsertAccount
   */
  upsertAccount: {
    methodKind: "unary";
    input: typeof UpsertAccountRequestSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof AccountIdSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ListAccounts
   */
  listAccounts: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAccountsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof AccountIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ToggleAccount
   */
  toggleAccount: {
    methodKind: "unary";
    input: typeof ToggleAccountRequestSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.RestartAccount
   */
  restartAccount: {
    methodKind: "unary";
    input: typeof AccountIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SetLeverage
   */
  setLeverage: {
    methodKind: "unary";
    input: typeof SetLeverageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetAccountSymbols
   */
  getAccountSymbols: {
    methodKind: "unary";
    input: typeof AccountIdSchema;
    output: typeof SymbolsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeAccounts
   */
  subscribeAccounts: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof AccountUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeOrders
   */
  subscribeOrders: {
    methodKind: "server_streaming";
    input: typeof SubscribeOrdersRequestSchema;
    output: typeof OrderUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.UpsertScript
   */
  upsertScript: {
    methodKind: "unary";
    input: typeof UpsertScriptRequestSchema;
    output: typeof ScriptSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetScript
   */
  getScript: {
    methodKind: "unary";
    input: typeof ScriptIdSchema;
    output: typeof ScriptSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ListScripts
   */
  listScripts: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListScriptsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.DeleteScript
   */
  deleteScript: {
    methodKind: "unary";
    input: typeof ScriptIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetScriptRevision
   */
  getScriptRevision: {
    methodKind: "unary";
    input: typeof GetScriptRevisionRequestSchema;
    output: typeof ScriptRevisionSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ListScriptRevisions
   */
  listScriptRevisions: {
    methodKind: "unary";
    input: typeof ListScriptRevisionsRequestSchema;
    output: typeof ListScriptRevisionsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeScripts
   */
  subscribeScripts: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof ScriptUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.UpsertBacktest
   */
  upsertBacktest: {
    methodKind: "unary";
    input: typeof UpsertBacktestRequestSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ToggleBacktest
   */
  toggleBacktest: {
    methodKind: "unary";
    input: typeof ToggleBacktestRequestSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetBacktest
   */
  getBacktest: {
    methodKind: "unary";
    input: typeof BacktestIdSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ListBacktests
   */
  listBacktests: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListBacktestsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.DeleteBacktest
   */
  deleteBacktest: {
    methodKind: "unary";
    input: typeof BacktestIdSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.AddBacktestAccount
   */
  addBacktestAccount: {
    methodKind: "unary";
    input: typeof AddBacktestAccountRequestSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.RemoveBacktestAccount
   */
  removeBacktestAccount: {
    methodKind: "unary";
    input: typeof RemoveBacktestAccountRequestSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.UpdateBacktestAccount
   */
  updateBacktestAccount: {
    methodKind: "unary";
    input: typeof UpdateBacktestAccountRequestSchema;
    output: typeof BacktestSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.SubscribeBacktests
   */
  subscribeBacktests: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof BacktestUpdateSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetConfigurableList
   */
  getConfigurableList: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigurableListSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetConfigurableParams
   */
  getConfigurableParams: {
    methodKind: "unary";
    input: typeof GetParamsRequestSchema;
    output: typeof ParamsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.ValidateConfigurable
   */
  validateConfigurable: {
    methodKind: "unary";
    input: typeof GetParamsRequestSchema;
    output: typeof ValidateResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.AppService.GetConfigurableProviders
   */
  getConfigurableProviders: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ProviderInfosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_app, 0);

